import { render, staticRenderFns } from "./PlayCards.vue?vue&type=template&id=c3d8a5e8&scoped=true&"
import script from "./PlayCards.vue?vue&type=script&lang=js&"
export * from "./PlayCards.vue?vue&type=script&lang=js&"
import style0 from "./PlayCards.vue?vue&type=style&index=0&id=c3d8a5e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d8a5e8",
  null
  
)

export default component.exports